import { render } from "./BookingConfirm.vue?vue&type=template&id=143c4c52&ts=true"
import script from "./BookingConfirm.vue?vue&type=script&lang=ts"
export * from "./BookingConfirm.vue?vue&type=script&lang=ts"

import "./BookingConfirm.vue?vue&type=style&index=0&id=143c4c52&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__